'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgChatbubbleWrite } from '@common/icon';
import { useEffect, useState } from 'react';
import { PageNavigation } from '@/components/client';
import { useGlobalStore } from '@/stores/GlobalStore';
import { Chat } from './_components/Chat';
const WelloAgentPage = () => {
  const $ = _c(8);
  const setHideBottomNav = useGlobalStore(_temp);
  const [chatKey, setChatKey] = useState(0);
  let t0;
  let t1;
  if ($[0] !== setHideBottomNav) {
    t0 = () => {
      setHideBottomNav(true);
      return () => setHideBottomNav(false);
    };
    t1 = [setHideBottomNav];
    $[0] = setHideBottomNav;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setChatKey(_temp2);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleReset = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PageNavigation backButtonType="exit" className="z-[2] items-center justify-between border-b border-Gray-100 bg-Gray-white/90 backdrop-blur-md" hideHomeButton={true} title={"\uC6F0\uB85C AI"}><Button aria-label={"\uC0C8 \uB300\uD654 \uC2DC\uC791\uD558\uAE30"} className="relative size-26 p-0" dimensions="H26" theme="primary-text" onClick={handleReset}><SvgChatbubbleWrite className="size-24" /></Button></PageNavigation>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <button aria-label={"\uC0C8 \uB300\uD654 \uC2DC\uC791\uD558\uAE30"} className="fixed right-24 top-80 z-20 hidden size-40 items-center justify-center rounded-pill text-Gray-400 transition-colors hover:bg-Gray-100 hover:text-Gray-700 xl:flex" type="button" onClick={handleReset}><SvgChatbubbleWrite className="size-20" /></button>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== chatKey) {
    t5 = <div className="mx-auto flex min-h-dvh w-full max-w-root flex-col bg-Gray-white">{t3}{t4}<Chat key={chatKey} /></div>;
    $[6] = chatKey;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default WelloAgentPage;
function _temp(state) {
  return state.setHideBottomNav;
}
function _temp2(prev) {
  return prev + 1;
}